import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ChatState {
  unreadCounts: Record<string, number>; // chatRoomId -> unread count
  setUnreadCount: (chatRoomId: string, count: number) => void;
  incrementUnreadCount: (chatRoomId: string) => void;
  clearUnreadCount: (chatRoomId: string) => void;
  getUnreadCount: (chatRoomId: string) => number;
  getTotalUnreadCount: () => number;
}

export const useChatStore = create<ChatState>()(
  persist(
    (set, get) => ({
      unreadCounts: {},

      setUnreadCount: (chatRoomId: string, count: number) =>
        set((state) => ({
          unreadCounts: {
            ...state.unreadCounts,
            [chatRoomId]: count,
          },
        })),

      incrementUnreadCount: (chatRoomId: string) =>
        set((state) => ({
          unreadCounts: {
            ...state.unreadCounts,
            [chatRoomId]: (state.unreadCounts[chatRoomId] || 0) + 1,
          },
        })),

      clearUnreadCount: (chatRoomId: string) =>
        set((state) => ({
          unreadCounts: {
            ...state.unreadCounts,
            [chatRoomId]: 0,
          },
        })),

      getUnreadCount: (chatRoomId: string) => {
        return get().unreadCounts[chatRoomId] || 0;
      },

      getTotalUnreadCount: () => {
        const counts = get().unreadCounts;
        return Object.values(counts).reduce((total, count) => total + count, 0);
      },
    }),
    {
      name: 'chat-storage',
      partialize: (state) => ({ unreadCounts: state.unreadCounts }),
    }
  )
);
